<template>
	<a-modal width="55%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<a-descriptions :column="2">
			<a-descriptions-item label="企业名称">{{ form.companyName }}</a-descriptions-item>
			<a-descriptions-item label="需求名称">{{ form.name }}</a-descriptions-item>
			<a-descriptions-item label="需求类型">
				<dict-render :dict-obj="dictObjs['demand_type']" :text="form.trType" v-if="form.trType"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="所属高新技术领域">
				<dict-render :dict-obj="dictObjs['belong_techField']" :text="form.highTechField"
					v-if="form.highTechField"></dict-render>
			</a-descriptions-item>
			<!-- <a-descriptions-item label="项目阶段">
				<dict-render :dict-obj="dictObjs['projectStage']" :text="form.projectPhase"
					v-if="form.projectPhase"></dict-render>
			</a-descriptions-item> -->
			<!-- <a-descriptions-item label="需求优先级">
				<dict-render :dict-obj="dictObjs['demand_priority']" :text="form.priority" v-if="form.priority"></dict-render>
			</a-descriptions-item> -->
			<a-descriptions-item label="研究经费(万元)">{{ form.researchFunding }}</a-descriptions-item>
			<a-descriptions-item label="截止日期">{{ form.deadline && form.deadline.split(' ')[0] }}</a-descriptions-item>
			<a-descriptions-item label="需求价值">
				<dict-render :dict-obj="dictObjs['demand_value']" :text="form.demandValue" v-if="form.demandValue"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="需求对接人">{{ form.dockingPerson }}</a-descriptions-item>
			<a-descriptions-item label="联系电话">{{ form.contactNumber }}</a-descriptions-item>
			<a-descriptions-item label="合作类型">
				<dict-render :dict-obj="dictObjs['cooperation_methods']" :text="form.typeCooperation"
					v-if="form.typeCooperation"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="需求描述" :span="2">{{ form.description }}</a-descriptions-item>
			<a-descriptions-item label="附件">
				<img-upload v-model:value="form.file" :showBtn="false" :disabled="true" />
			</a-descriptions-item>
		</a-descriptions>
		<!-- <div class="pingguInfo">对接信息</div>
		<a-table :columns="columns" :data-source="form.list" bordered :pagination="false">
			<template #headShot="{ record }">
				<div style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
					<img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.headShot" :showList="true"
						disabled />
				</div>
			</template>
			<template #name="{ record }">
				<a @click="onDetail(record)">{{ record.name }}</a>
			</template>
			<template #dateBirth="{ text }">
				<span>{{ text && text.split(' ')[0] }}</span>
			</template>
			<template #educationBackground="{ text }">
				<dict-render :dict-obj="dictObjs['education_background']" :text="text" v-if="text"></dict-render>
			</template>
			<template #researchArea="{ text }">
				<dict-render :dict-obj="dictObjs['research_field']" :text="text" v-if="text"></dict-render>
			</template>
			<template #approveType="{ text }">
				<dict-render :dict-obj="dictObjs['expert_type']" :text="text" v-if="text"></dict-render>
			</template>
		</a-table> -->
	</a-modal>
</template>
<script>
import { formMixin, dictMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";

const columns = [
	{ title: "用户头像", dataIndex: "headShot", key: "headShot", slots: { customRender: "headShot" } },
	{ title: "技术经理人姓名", dataIndex: "name", key: "name", slots: { customRender: "name" } },
	{
		title: "性别", dataIndex: "sex", key: "sex", customRender: (text) => {
			if (text.text == '0') {
				return <span>男</span>
			} else {
				return <span>女</span>
			}
		}
	},
	{ title: "手机号码", dataIndex: "phoneNumber", key: "phoneNumber" },
	{ title: "学历", dataIndex: "educationBackground", key: "educationBackground", slots: { customRender: "educationBackground" } },
	{ title: "研究领域", dataIndex: "researchArea", key: "researchArea", slots: { customRender: "researchArea" } },
	{ title: "工作单位", dataIndex: "unitWork", key: "unitWork" },
];
export default {
	name: "DetailModal",
	components: {
		DictRender
	},

	mixins: [formMixin, dictMixin],
	data() {
		return {
			columns,
			dictNames: "demand_type,belong_techField,projectStage,demand_priority,demand_value,cooperation_methods,education_background,research_field,expert_type",
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less">
.pingguInfo {
	-webkit-box-flex: 1;
	-ms-flex: auto;
	flex: auto;
	overflow: hidden;
	color: rgba(0, 0, 0, 0.85);
	font-weight: bold;
	font-size: 16px;
	line-height: 1.5715;
	white-space: nowrap;
	text-overflow: ellipsis;
	margin-bottom: 15px;
}
</style>
